export default {
  dataView: 'Vista de Datos',
  close: 'Cerrar',
  refresh: 'Actualizar',
  saveAsImage: 'Guardar como Imagen'
}
